import styleInject from 'style-inject';

var css_248z = ".Pagination-module_button__4O8Dp{color:var(--color-text);cursor:pointer}.Pagination-module_button__4O8Dp.Pagination-module_disabled__HLW1m{color:var(--color-muted);cursor:default}.Pagination-module_content__OBvh-{color:var(--color-link);font-size:var(--size--1)}";
var styles = {"button":"Pagination-module_button__4O8Dp","disabled":"Pagination-module_disabled__HLW1m","content":"Pagination-module_content__OBvh-"};
styleInject(css_248z);

export { styles as default };
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiUGFnaW5hdGlvbi5tb2R1bGUuc2Nzcy5qcyIsInNvdXJjZXMiOltdLCJzb3VyY2VzQ29udGVudCI6W10sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7Ozs7OyJ9
